import {
  IMobileOrchestrator,
  IMultiOrderOrchestrator,
} from "@nju/data-access-portal-orchestrator";
import { IMobileOrderProductsResponse } from "@nju/data-access-portal-product";

const phaseInProgress = new Set<IMobileOrchestrator["state"]>([
  "ORDER_PAYMENT",
  "ORDER_ACTIVATE",
  "ORDER_FINISHING",
  "ORDER_COMMITTED",
  "ORDER_FULFILLMENT",
  "ORDER_PAYMENT_ERROR",
  "ORDER_PENDING_CANCELLATION",
  "PAYMENT_METHOD",
  "ACTIVATION",
  "DELIVERY",
  "SIM",
]);

const phaseCompleted = "COMPLETED";

export function getMobileOrchestratorPhase(
  mobileOrchestrator: IMobileOrchestrator | undefined,
  multiOrderOrchestrator: IMultiOrderOrchestrator | undefined,
  mobileProducts: IMobileOrderProductsResponse | undefined,
) {
  const mobileProductsStatus = mobileProducts?.mobileAccess?.status;
  const phaseResignation =
    mobileProductsStatus &&
    ["PendingTermination", "PendingCancellation"].includes(
      mobileProductsStatus,
    );
  const productPhase =
    mobileProductsStatus &&
    ["Active", "NoPayment", "Suspended"].includes(mobileProductsStatus);

  if ((!mobileOrchestrator && !multiOrderOrchestrator) || !mobileOrchestrator) {
    return "phaseEmpty";
  }
  if (phaseInProgress.has(mobileOrchestrator.state)) {
    return "phaseInProgress";
  }
  if (mobileOrchestrator?.state === phaseCompleted && phaseResignation) {
    return "phaseResignation";
  }
  if (mobileOrchestrator?.state === phaseCompleted && productPhase) {
    return "phaseCompleted";
  }
  return;
}
